import useOpenHelpCenter from 'hooks/help-center/useOpenHelpCenter';
import { Trans, useTranslation } from 'react-i18next';

const CarrierServiceWarning = () => {
    const { t } = useTranslation();

    const openHelpCenter = useOpenHelpCenter(8286656, 'article', 'carrier_service_warning');

    return (
        <s-banner heading={t('INTEGRATION_MODE.WARNING_BANNER.DESC')} tone="warning" dismissible>
            <div className="flex flex-col gap-2">
                <s-text>{t('INTEGRATION_MODE.WARNING_BANNER.PLANS')}</s-text>
                <s-text>
                    {/* "here" opens the same help center article as the "More details" button */}
                    <Trans
                        i18nKey="INTEGRATION_MODE.WARNING_BANNER.MORE_INFO"
                        components={{ helplink: <s-link onClick={openHelpCenter}></s-link> }}
                    />
                </s-text>
            </div>
            <s-button slot="secondary-actions" onClick={openHelpCenter}>
                {t('INTEGRATION_MODE.WARNING_BANNER.MORE_DETAILS')}
            </s-button>
        </s-banner>
    );
};

export default CarrierServiceWarning;
